<template>
  <div style="width: 240px; margin: auto">
    <el-form ref="pwd-change-form" :model="m" size="mini">
      <div class="text-center"><h2>设置新密码</h2></div>
      <el-form-item label="密码" prop="pwd" :rules="[{required: true, message: '密码不能为空'},
      {min: 4, message: '密码不少少于4位'}]">
        <el-input type="password" v-model="m.pwd" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmedPwd" :rules="[{validator: confirmPwdCheck}]">
        <el-input type="password" v-model="m.confirmedPwd" placeholder="请再次输入密码"></el-input>
      </el-form-item>
      <div class="text-center">
        <el-button size="small" type="primary" @click="submit">提交</el-button>
        <el-button size="small" @click="cancel">放弃</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import User from "@/models/User";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "UserPwdForm",
  props: {
    model: {
      default: () => new User()
    }
  },
  data() {
    return {
      m: {
        pwd: '',
        confirmedPwd: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser'
    })
  },
  methods: {
    ...mapActions({
      modifyPwd: 'modifyPwd'
    }),
    confirmPwdCheck(r, v, cb) {
      if (!v) {
        return cb(new Error("确认密码不能为空"))
      }
      if (v !== this.m.pwd) {
        return cb(new Error(("两次密码输入不一致，请检查")))
      }
      return cb()
    },
    submit() {
      this.$refs['pwd-change-form'].validate(valid => {
        if (valid) {
          this.modifyPwd({id: this.user.id, pwd: this.m.pwd})
              .then( () => {
                this.$emit('success')
                this.$message.success('操作成功')
              })
        }
      })
    },
    cancel() {
      this.m = {
        pwd: '',
        confirmedPwd: ''
      }
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
